import * as React from 'react';

import { DynamicCalltrackingButton } from 'shared/components/DynamicCalltrackingButton';

import * as styles from './CallButton.css';

interface ICallButtonProps {
  announcementId: number;
  handleShowPhoneClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent> | MouseEvent): void;
  isPhonesVisible: boolean;
  phone: string;
  siteBlockId: number | null;
}

export const CallButton = ({
  announcementId,
  handleShowPhoneClick,
  isPhonesVisible,
  phone,
  siteBlockId,
}: ICallButtonProps) => {
  return (
    <DynamicCalltrackingButton
      blockId={siteBlockId}
      buttonText="Показать контакты"
      isOpen={isPhonesVisible}
      announcementId={announcementId}
      onClick={handleShowPhoneClick}
      openPhoneClassName={styles['phones']}
      phone={phone}
      placeType="newbuildingPromosBanner"
      buttonSize="XS"
      buttonTheme="fill_secondary"
    />
  );
};
